import React, { useState, useEffect, useRef } from "react";

export default function NivelesTable({
  niveles = [],
  loading,
  reload,
  onEdit,
  onDelete,
  canEdit,
  canDelete,
}) {
  const canManage = canEdit || canDelete;
  const [openMenuId, setOpenMenuId] = useState(null);
  const [menuPos, setMenuPos] = useState({ top: 0, right: 0 });
  const wrapRef = useRef(null);

  useEffect(() => {
    const handleOutside = (e) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) {
        setOpenMenuId(null);
      }
    };
    document.addEventListener("mousedown", handleOutside);
    return () => document.removeEventListener("mousedown", handleOutside);
  }, []);

  if (loading) {
    return (
      <div className="management-card text-center py-5">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Cargando...</span>
        </div>
      </div>
    );
  }

  if (!niveles.length) {
    return (
      <div className="management-card niveles-empty text-center py-5">
        <i className="bi bi-layers niveles-empty-icon d-block mb-3" />
        <h5 className="fw-semibold mb-1">No hay niveles registrados.</h5>
        <p className="text-muted mb-0">Crea un nivel o actualiza la lista.</p>
      </div>
    );
  }

  return (
    <div className="management-card niveles-table-card">
      <div className="d-flex align-items-center justify-content-between mb-3 flex-wrap gap-3">
        <div>
          <p className="management-label mb-1">Listado</p>
          <h5 className="mb-0">Historial de niveles</h5>
        </div>
        <button
          type="button"
          className="btn btn-outline-secondary btn-sm"
          onClick={reload}
          disabled={loading}
        >
          <i className="bi bi-arrow-repeat me-2" />
          Actualizar
        </button>
      </div>
      <div className="management-table-wrapper">
        <table className="table align-middle management-table niveles-table mb-0">
          <thead>
            <tr>
              <th>#</th>
              <th>Nombre</th>
              <th>Descripcion</th>
              <th>Estado</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody ref={wrapRef}>
            {niveles.map((nivel, index) => {
              const isMenuOpen = openMenuId === nivel.id;
              return (
                <tr key={nivel.id}>
                  <td>{index + 1}</td>
                  <td className="fw-semibold">{nivel.nombre}</td>
                  <td>{nivel.descripcion || "-"}</td>
                  <td>
                    <span
                      className={`badge rounded-pill px-3 py-2 ${
                        nivel.activo ? "bg-success-subtle text-success" : "bg-secondary-subtle text-muted"
                      }`}
                    >
                      {nivel.activo ? "Activo" : "Inactivo"}
                    </span>
                  </td>
                  <td>
                    {canManage ? (
                      <div className="management-actions-wrap">
                        <button
                          type="button"
                          className={`management-actions-toggle${isMenuOpen ? " is-open" : ""}`}
                          onClick={(e) => {
                            e.stopPropagation();
                            if (!isMenuOpen) {
                              const rect = e.currentTarget.getBoundingClientRect();
                              setMenuPos({ top: rect.bottom + 4, right: window.innerWidth - rect.right });
                            }
                            setOpenMenuId(isMenuOpen ? null : nivel.id);
                          }}
                          title="Acciones"
                          aria-expanded={isMenuOpen}
                        >
                          <i className="bi bi-three-dots-vertical" />
                        </button>
                        {isMenuOpen && (
                          <ul className="management-actions-menu" style={{ position: "fixed", top: menuPos.top, right: menuPos.right, left: "auto" }}>
                            {canEdit && (
                              <li>
                                <button
                                  type="button"
                                  className="menu-item"
                                  onClick={(e) => { e.stopPropagation(); setOpenMenuId(null); onEdit?.(nivel); }}
                                >
                                  <i className="bi bi-pencil-square" />
                                  Editar
                                </button>
                              </li>
                            )}
                            {canDelete && (
                              <li>
                                <button
                                  type="button"
                                  className="menu-item is-danger"
                                  onClick={(e) => { e.stopPropagation(); setOpenMenuId(null); onDelete?.(nivel); }}
                                >
                                  <i className="bi bi-trash" />
                                  Eliminar
                                </button>
                              </li>
                            )}
                          </ul>
                        )}
                      </div>
                    ) : (
                      <span className="text-muted small">Sin permisos</span>
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
